document.addEventListener('DOMContentLoaded', () => {
    new ImageZoom('.item-type__media__main-media'); // Initialize zoom effect for all images in the specified container
  });

/**
 * Class for applying mouse-follow zoom effects to visible images within a container.
 */
export class ImageZoom {
    private container: HTMLElement;
  
    /**
     * Create a new ImageZoom instance.
     * @param containerSelector - A CSS selector for the zoom container.
     */
    constructor(containerSelector: string) {
      const container = document.querySelector(containerSelector);

      if (!container) throw new Error(`Container not found: ${containerSelector}`);
  
      this.container = container as HTMLElement;
      this.init();
    }
  
    /**
     * Initialize event listeners on the container.
     */
    private init(): void {
      this.container.addEventListener('mousemove', this.handleMouseMove.bind(this));
      this.container.addEventListener('mouseleave', this.resetZoom.bind(this));
    }
  
    /**
     * Handle mouse movement within the container and apply zoom to the visible image.
     * @param event - The mouse event.
     */
    private handleMouseMove(event: MouseEvent): void {
      const images = this.getVisibleImages();
  
      images.forEach((img) => {
        const rect = img.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
  
        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = 'scale(3)';
      });
    }
  
    /**
     * Reset zoom on all images when the mouse leaves the container.
     */
    private resetZoom(): void {
      const images = this.container.querySelectorAll<HTMLImageElement>('.picture .image');
      images.forEach((img) => {
        img.style.transform = 'scale(1)';
        img.style.transformOrigin = 'center center';
      });
    }
  
    /**
     * Get all visible <img> elements inside `.picture` with class `.image`.
     * Visibility is determined via `data-display=""`.
     */
    private getVisibleImages(): HTMLImageElement[] {
      const images = this.container.querySelectorAll<HTMLImageElement>('.picture .image');
  
      return Array.from(images).filter((img) => {
        const attr = img.getAttribute('data-display');
        return attr === null || attr === '';
      });
    }
  }
  